import { render, staticRenderFns } from "./coming-soon.html?vue&type=template&id=672ecd96&scoped=true&external"
import script from "./coming-soon.js?vue&type=script&lang=js&external"
export * from "./coming-soon.js?vue&type=script&lang=js&external"
import style0 from "./coming-soon.scss?vue&type=style&index=0&id=672ecd96&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ecd96",
  null
  
)

export default component.exports